import { ImgHTMLAttributes } from 'react';
import LazyImage from '../LazyImage';

const VaultIcon = ({
  src,
  unverified,
  ...rest
}: {
  unverified: boolean;
  src?: string;
} & ImgHTMLAttributes<HTMLImageElement | HTMLSpanElement>) => {
  if (unverified) {
    return (
      <span
        {...rest}
        className={`${rest.className || ''} items-center justify-center flex`}
        title="vault not verified"
      >
        {'?'}
      </span>
    );
  }

  // TODO: what are we doing about vault icons that dont exist?
  return <LazyImage src={src} {...rest} />;
};

export default VaultIcon;
